import * as Sentry from "@sentry/react";
import ReactGA from "react-ga4";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "contexts/JWTAuthContext";
import SettingsProvider from "contexts/SettingsContext";
import TitleContextProvider from "contexts/TitleContext";
import "nprogress/nprogress.css";
import { StrictMode } from "react";
import ReactDOM from "react-dom";
import "react-image-lightbox/style.css";
import { BrowserRouter } from "react-router-dom";
import "simplebar/dist/simplebar.min.css";
import App from "./App";

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    tracesSampleRate: 0.1,
    release: process.env.REACT_APP_VERSION,
  });
}

if (process.env.REACT_APP_GA_MEASUREMENT_ID) {
  ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);
}

ReactDOM.render(
  <StrictMode>
    <HelmetProvider>
      <Sentry.ErrorBoundary
        fallback={
          <p>Ocorreu um erro inesperado. Por favor, recarregue a página.</p>
        }
        showDialog={false}
      >
        <AuthProvider>
          <SettingsProvider>
            <TitleContextProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </TitleContextProvider>
          </SettingsProvider>
        </AuthProvider>
      </Sentry.ErrorBoundary>
    </HelmetProvider>
  </StrictMode>,
  document.getElementById("root")
);
